/** @format */

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import {styled} from '@mui/material/styles';
import {Trans} from 'react-i18next';

const PREFIX = 'InformationDialog';

const classes = {
  title: `${PREFIX}-title`,
};

const StyledDialog = styled(Dialog)(({theme}) => ({
  [`& .${classes.title}`]: {
    color: theme.palette.text.secondary,
  },
}));

interface Props {
  open: boolean;
  onClose: () => void;
  body?: string | null;
  title: string;
}

const InformationDialog = ({open, title, body, onClose}: Props) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogTitle className={classes.title}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color='primary'
          disableElevation
          fullWidth={false}
          size='medium'
          variant='contained'
          onClick={onClose}
        >
          <Trans>Закрыть</Trans>
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default InformationDialog;
